enum EParamsView {
  String = 'String',
  NumFill = '_NumFill_',
  DateRange = '_DateRange_',
  DateFrom = '_DateFrom_',
}

export default EParamsView;